import api from "../axiosInstance";

export const getTermsAndConditionAPI = async () => {
  const response = await api.get(
    `${process.env.REACT_APP_API_URL}/api/v1/term-and-condition`
  );
  return response;
};

export const updateTermsAndConditionAPI = async (payload) => {
  const response = await api.put(
    `${process.env.REACT_APP_API_URL}/api/v1/term-and-condition`,
    payload
  );
  return response;
};
